import { FeatureNameEnum } from '../shared/feature/feature-name.enum';
import { FeatureService } from '../shared/feature/feature.service';
import { LicenseService } from '../shared/license/license.service';
import { UserRead } from '../users/shared/user-read.model';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PagedResultGeneric } from '../shared/model/paged-result.model';
import { SalesOpportunityService } from '../sales-opportunities/shared/sales-opportunity.service';
import { UserService } from '../users/shared/user.service';
import { ConfigService } from '../config/shared/config.service';
import { SalesOpportunitySearchDto } from '../sales-opportunities/shared/dto/sales-opportunity-search.dto';
import { SalesOpportunityDto } from '../sales-opportunities/shared/dto/sales-opportunity.dto';
import { TaskService } from '../tasks/shared/task.service';
import { TaskSearchDto } from '../tasks/shared/dto/task-search.dto';
import { NotificationService } from '../shared';

@Component({
  selector: 'wl-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.css'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardComponent implements OnInit {
  private _userService: UserService;

  public hideEvents: boolean;
  public hideRevenue: boolean;
  public hideSalesOpps = true;
  public hideTasks = true;

  public constructor(
    userService: UserService,
    private _configService: ConfigService,
    private _salesOppService: SalesOpportunityService,
    private _taskService: TaskService,
    private _featureService: FeatureService
  ) {
    this._userService = userService;
    this.hideEvents = true;
    this.hideRevenue = true;
  }

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Event Reports').then((data: number) => {
      if (data > 0) {
        this.hideEvents = false;
        //console.log('?> in onInit:', this.hideEvents);
      }
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Revenue Reports').then((data: number) => {
      if (data > 0) {
        this.hideRevenue = false;
      }
    });

    this._featureService.has(FeatureNameEnum.SalesOpportunities).then((featureLicense) => {
      if (featureLicense) {
        this._userService.getCurrentUser().then((data: UserRead) => {
          const search = { AssignedTo: data.UserNum, PageSize: 1 } as SalesOpportunitySearchDto;
          this._salesOppService.search(search).then((result: PagedResultGeneric<SalesOpportunityDto>) => {
            this.hideSalesOpps = result.TotalCount <= 0;
          });
        });
      }
    });

    const search: TaskSearchDto = {
      PageSize: 10,
      PageNumber: 1,
      OrderBy: 'DateDue',
      TotalPages: 1,
      TotalCount: 0,
    } as TaskSearchDto;
    this._taskService.getMyTasks(search, true).then((data) => {
      this.hideTasks = data.TotalCount <= 0;
    });
  }

  scrollToElement(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
